module.exports = __webpack_public_path__ + "c262daac7d5bb5536332d76db188d4c3.png";